<template>
    <div
        class="kgr-pageHeader__item"
    >
        <!-- Hidden rather than swapped for a spinner while loading: the header's items are right-aligned, so a change of width here moves everything to its left. -->
        <a
            v-show="!accessDenied"
            :class="classAttributes"
            :href="url"
            :title="title"
            :style="{ visibility: loading ? 'hidden' : undefined }"
        >
            {{ counterData }}
        </a>
    </div>
</template>

<script>
import EventBus from '../../js/service/EventBus';
import hintRepositoryFor from '../../js/repository/hintRepositoryFor';

export default {
    name: 'HintCounter',
    props: {
        institutionType: {
            type: String,
            default: 'club',
            validator: (value) => ['club', 'kindergarten'].includes(value),
        },
        institutionId: {
            type: Number,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            counterData: 0,
            accessDenied: false,
        };
    },
    computed: {
        repository() {
            return hintRepositoryFor(this.institutionType);
        },
        title() {
            if (this.counterData === 1) {
                return `${this.counterData} ${this.$t('choice_hint_singular')}`;
            }
            return `${this.counterData} ${this.$t('choice_hint_plural')}`;
        },
        classAttributes() {
            const attr = this.counterData > 0 ? 'kgr-badge--warning' : 'kgr-badge--info';
            return `kgr-badge ${attr}`;
        },
    },
    created() {
        this.loadCounter();
        this.unbindProblemCreated = EventBus.$on('hint:problem-created', this.loadCounter);
    },
    beforeUnmount() {
        this.unbindProblemCreated?.();
    },
    methods: {
        loadCounter() {
            this.loading = true;
            this.repository.getCount(this.institutionId)
                .then((response) => {
                    this.counterData = response;
                    this.accessDenied = false;
                })
                .catch((response) => {
                    this.accessDenied = response.status === 403;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">

</style>
